import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import ResourceDropdown from '@src/components/common/Dropdowns/GuideResourceTypesDropdown';
import ProductsDropdown from '@src/components/common/Dropdowns/ProductsDropdown';
import StatesDropdown from '@src/components/common/Dropdowns/StatesDropdown';

const FindGuidelinesLayout = ({
    selectedResource,
    selectedState,
    selectedProduct,
    showProduct,
    onResourceSelect,
    onStateSelect,
    onProductSelect,
    onGoClick,
}) => {
    const mdColSize = showProduct ? 4 : 6;
    return (
        <Row className="find-guidelines-manuals main-container-row shadow mb-5">
            <Col xs={12} lg={3} className="guidelines-title-col">
                <div className="guidelines-title-container">
                    <h2>UW Guides and Rate Bulletins:</h2>
                </div>
            </Col>
            <Col xs={12} lg={9} className="bg-alt-col">
                <div className="bg-alt">
                    <Row className="align-items-center">
                        <Col xs={12} lg={10} className="select-container">
                            <Row>
                                <Col xs={12} md={mdColSize}>
                                    <StatesDropdown
                                        selectedState={selectedState}
                                        onChange={onStateSelect}
                                    />
                                </Col>
                                <Col xs={12} md={mdColSize}>
                                    <ResourceDropdown
                                        selectedResourceType={selectedResource}
                                        onChange={onResourceSelect}
                                    />
                                </Col>
                                {
                                    showProduct
                                    && (
                                        <Col xs={12} md={4}>
                                            <ProductsDropdown
                                                selectedProduct={selectedProduct}
                                                onChange={onProductSelect}
                                            />
                                        </Col>
                                    )
                                }

                            </Row>
                        </Col>
                        <Col xs={12} lg={2} className="button-container">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={onGoClick}
                            >
                                Go
                            </button>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    );
};

FindGuidelinesLayout.propTypes = {
    selectedResource: PropTypes.string,
    selectedState: PropTypes.string,
    selectedProduct: PropTypes.string,
    showProduct: PropTypes.bool,
    onResourceSelect: PropTypes.func.isRequired,
    onStateSelect: PropTypes.func.isRequired,
    onProductSelect: PropTypes.func.isRequired,
    onGoClick: PropTypes.func.isRequired,
};

export default React.memo(FindGuidelinesLayout);
